import { AvvirEvent } from "type_aliases";

export type ZipProjectFolderStartedEvent = AvvirEvent<typeof ZIP_PROJECT_FOLDER_STARTED, { projectId: string, folderName: string }>

const zipProjectFolderStarted = (projectId: string, folderName: string): ZipProjectFolderStartedEvent => ({
  type: ZIP_PROJECT_FOLDER_STARTED,
  payload: {
    projectId,
    folderName
  }
});

export const ZIP_PROJECT_FOLDER_STARTED = "zip_project_folder_started";

export default zipProjectFolderStarted;
